function CompanyLogoBlack() {
    return (
        <svg
            width="100"
            height="48"
            viewBox="0 0 100 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_0_303)">
                <path
                    d="M65.6876 8.17773C62.3375 8.26339 35.4854 9.20269 35.4854 9.20269L35.6604 9.64884H39.4655L35.7549 9.88679L35.8133 10.0403C35.8133 10.0403 53.4545 9.93794 54.7612 9.71606C56.0678 9.49417 56.3023 9.22053 56.3023 9.22053C56.3023 9.22053 68.8703 8.89871 71.5274 7.427C71.5361 7.42641 69.0401 8.09266 65.6876 8.17773Z"
                    fill="url(#paint0_linear_0_303)"
                />
                <path
                    d="M10.6622 13.4905C7.44627 14.2763 6.2901 16.5755 6.2901 16.5755C6.2901 16.5755 7.99927 14.074 12.505 13.8521C17.0106 13.6303 29.4403 13.4078 29.4403 13.4078C29.4403 13.4078 13.8787 12.7046 10.6622 13.4905Z"
                    fill="url(#paint1_linear_0_303)"
                />
                <path
                    d="M88.2044 13.4905C91.4209 14.2763 92.5794 16.5725 92.5794 16.5725C92.5794 16.5725 90.8708 14.0711 86.3651 13.8492C81.8595 13.6273 69.4297 13.4048 69.4297 13.4048C69.4297 13.4048 84.9873 12.7047 88.2044 13.4905Z"
                    fill="url(#paint2_linear_0_303)"
                />
                <path
                    d="M60.9159 0.200453C48.2517 -0.67103 42.3974 1.4818 37.7739 3.1748C33.1503 4.8678 29.1055 8.37693 24.8821 9.04259C20.6588 9.70825 9.31818 9.52265 4.83583 10.8867C3.10858 11.4131 1.99032 11.8135 1.34282 12.0633C1.25457 12.0971 1.17489 12.1507 1.10967 12.2202C1.04445 12.2896 0.995357 12.3731 0.966015 12.4644C0.936673 12.5558 0.927832 12.6527 0.940145 12.748C0.952458 12.8433 0.985611 12.9346 1.03716 13.0151C1.03716 13.0151 3.42416 11.5547 8.67885 10.8629C13.9335 10.1711 18.5541 10.4483 18.5541 10.4483C18.5541 10.4483 8.35276 10.9777 5.38767 12.1734C3.81266 12.8075 2.88341 13.1995 2.35433 13.5559C2.18013 13.6727 2.05801 13.8548 2.01436 14.0627C1.9707 14.2706 2.009 14.4877 2.12099 14.6671C2.12099 14.6671 4.8475 12.4298 9.58768 12.0027C13.5544 11.6457 26.9028 11.4673 31.1571 11.4185C31.5508 11.4144 31.9376 11.3132 32.2846 11.1235C32.6316 10.9338 32.9285 10.6613 33.1498 10.3293C33.6456 9.58809 34.3083 8.69697 34.7673 8.46735H36.0571C36.5932 8.46735 37.7155 7.78444 37.7657 7.63037C37.8159 7.4763 37.0966 6.70654 36.3925 6.6411C35.9113 6.5953 34.4284 8.18776 33.5383 9.19607H30.7511L32.623 7.54352L28.9766 9.6904H33.1089C32.9415 9.88612 32.8412 10.0075 32.8412 10.0075L26.8328 9.94322C26.7715 9.94291 26.7124 9.91985 26.6665 9.87837C26.6206 9.83688 26.5911 9.77979 26.5835 9.71774C26.5758 9.6557 26.5906 9.59294 26.625 9.54117C26.6594 9.48941 26.7111 9.45216 26.7704 9.43639C27.5556 9.22224 28.3833 8.97477 28.822 8.77728C29.8102 8.3335 38.4873 2.62812 49.7637 1.67097C55.9973 1.14213 62.2051 1.73403 66.5282 2.41575C66.6326 2.43229 66.7325 2.47067 66.8216 2.52849C66.9107 2.5863 66.9872 2.66229 67.0461 2.75167C67.1051 2.84106 67.1453 2.94192 67.1641 3.04791C67.183 3.15389 67.1802 3.26271 67.1559 3.36754L66.1339 7.79753L68.1802 3.1861C68.2389 3.05469 68.339 2.94705 68.4645 2.88033C68.5901 2.81361 68.734 2.79162 68.8732 2.81788C70.1087 3.05047 71.0695 3.26582 71.6732 3.42881C74.3361 4.14622 74.5374 4.4157 74.1104 5.31216C73.6834 6.20863 72.9169 6.8499 72.9169 6.8499C72.9169 6.8499 74.0836 6.28597 75.1779 4.94097C75.1779 4.94097 85.5933 7.56731 85.4673 7.81061C85.3413 8.05392 73.9091 8.22048 72.1755 8.70708C70.4418 9.19369 69.4116 10.8212 69.4116 10.8212C69.4116 10.8212 77.2178 9.76655 83.533 10.0568C89.8482 10.3471 91.9418 10.8427 92.5619 10.7058C93.182 10.569 93.7676 9.95452 93.7676 9.95452C93.7676 9.95452 94.7395 10.296 95.4931 10.1253C96.2468 9.95452 96.6656 9.20261 96.6656 9.20261C96.6656 9.20261 73.5796 1.07134 60.9159 0.200453ZM90.708 9.98248C89.1669 9.70944 79.1912 8.81 79.1912 8.81C82.2065 8.58752 92.5753 9.37334 92.5753 9.37334C92.5753 9.37334 92.2492 10.2561 90.708 9.98248Z"
                    fill="url(#paint3_linear_0_303)"
                />
                <path
                    d="M36.6859 5.81658C36.6859 5.81658 44.4017 2.28662 52.261 2.28662C60.1203 2.28662 66.3223 3.09565 66.3223 3.09565L65.2046 6.33114L36.6859 5.81658Z"
                    fill="url(#paint4_linear_0_303)"
                />
                <path
                    d="M68.2222 4.21165L67.272 6.60064C67.272 6.60064 71.8628 6.78446 72.5838 6.38054C73.3048 5.97662 73.7505 5.08135 73.593 4.78689C73.4763 4.56203 70.5422 3.95407 69.1754 3.684C68.9812 3.64542 68.7798 3.67698 68.6059 3.77325C68.432 3.86953 68.2963 4.02452 68.2222 4.21165Z"
                    fill="url(#paint5_linear_0_303)"
                />
                <path
                    d="M10.9655 17.1965V19.6539H3.30809V21.2535H10.78V23.7258H3.30809V28.0154H0V17.1965H10.9655Z"
                    fill="#262626"
                />
                <path
                    d="M20.7335 26.0381H14.3022L13.3467 28.0154H9.96747L15.3289 17.1965H19.6351L25.3104 28.0154H21.7316L20.7335 26.0381ZM17.4534 19.5379L15.4858 23.5949H19.5068L17.4534 19.5379Z"
                    fill="#262626"
                />
                <path
                    d="M31.1711 28.2046C25.6096 28.2046 24.9679 25.7615 24.9679 24.3379V24.1779H28.4329C28.4761 24.8323 28.8465 25.8935 31.5829 25.8935H31.7824C34.5772 25.8935 34.891 25.3266 34.891 24.7448C34.891 24.1196 34.5626 23.727 32.1103 23.6544L30.285 23.6104C26.3183 23.4914 25.1091 22.1274 25.1091 20.4404V20.3095C25.1091 18.6956 26.05 17.0092 30.8841 17.0092H31.8676C36.8843 17.0092 38.0282 18.7973 38.0282 20.4261V20.5712H34.5789C34.5078 20.1643 34.2937 19.2774 31.5129 19.2774H31.2848C28.7182 19.2774 28.5327 19.7426 28.5327 20.2078C28.5327 20.673 28.8208 21.0965 30.9856 21.1375L32.7683 21.1667C36.7606 21.2393 38.3718 22.2279 38.3718 24.379V24.5824C38.3718 26.3712 37.488 28.2034 32.1546 28.2034L31.1711 28.2046Z"
                    fill="#262626"
                />
                <path
                    d="M43.3342 19.7562H38.7708V17.1982H51.2623V19.7562H46.6849V28.0153H43.3342V19.7562Z"
                    fill="#262626"
                />
                <path
                    d="M63.5392 28.2045C57.3932 28.2045 56.4383 24.7001 56.4383 22.7805V22.3587C56.4383 20.3956 57.2649 17.0049 63.5392 17.0049H64.1225C70.2686 17.0049 71.2241 20.0001 71.2241 21.2653V21.4254H67.7019C67.6161 21.1345 67.1886 19.6223 63.8233 19.6223C60.6435 19.6223 59.9149 21.0762 59.9149 22.4283V22.6032C59.9149 23.8828 60.7561 25.5692 63.8507 25.5692C67.2871 25.5692 67.6296 23.897 67.7147 23.6502H71.2369V23.8102C71.2369 25.1784 70.1816 28.2015 64.1202 28.2015L63.5392 28.2045Z"
                    fill="#262626"
                />
                <path
                    d="M81.4377 26.0381H75.0035L74.048 28.0154H70.6687L76.0302 17.1965H80.3363L86.0116 28.0154H82.4329L81.4377 26.0381ZM78.1547 19.5379L76.1877 23.5949H80.2086L78.1547 19.5379Z"
                    fill="#262626"
                />
                <path
                    d="M89.9188 28.0154H86.5938V17.1965H95.1519C98.6881 17.1965 99.7602 18.4458 99.7602 20.0031V20.1774C99.7602 21.7336 98.4915 22.3154 97.7927 22.548C98.8765 22.868 99.8034 23.6384 99.8034 25.0345V26.6193C99.8034 27.4919 99.9032 27.7685 100.003 27.9428V28.0154H96.6236C96.5239 27.8846 96.4667 27.7245 96.4667 27.3319V26.0827C96.4667 24.7597 95.8962 24.1791 94.2565 24.1791H89.9217L89.9188 28.0154ZM89.9188 21.777H94.9524C95.9073 21.777 96.2941 21.3118 96.2941 20.7158V20.7009C96.2941 20.134 95.9236 19.6539 94.9524 19.6539H89.9188V21.777Z"
                    fill="#262626"
                />
                <path
                    d="M16.8555 48C24.8863 48 26.834 45.241 27.4354 42.5474L27.5037 42.2411C28.2282 39.0002 26.134 37.5113 20.1455 37.4018L17.4709 37.3578C14.2217 37.2924 13.9342 36.6571 14.0905 35.9563C14.2468 35.2555 14.6826 34.5548 18.5483 34.5548H18.8907C23.0779 34.5548 23.1018 35.8909 23.0721 36.5036H28.269L28.318 36.2847C28.8658 33.832 27.7487 31.139 20.1904 31.139H18.7093C11.4299 31.139 9.44539 33.6791 8.9023 36.1098L8.85855 36.3067C8.29096 38.8468 9.65655 40.905 15.5873 41.0805L18.3208 41.1436C21.9906 41.2536 22.3517 41.8443 22.1417 42.786C21.9457 43.6622 21.283 44.5159 17.0742 44.5159H16.7732C12.6508 44.5159 12.449 42.9175 12.6053 41.9318H7.38679L7.33313 42.1697C6.85363 44.3154 6.99829 47.9941 15.3732 47.9941H16.8555V48ZM41.7668 41.0585H35.7112L40.039 34.9492L41.7668 41.0585ZM43.63 47.7157H49.02L44.1113 31.4234H37.6292L25.9135 47.7157H31.0025L33.1066 44.7378H42.79L43.63 47.7157ZM53.5356 31.4234L49.8974 47.7157H66.0027L66.9074 43.6646H55.8054L58.5395 31.4234H53.5356ZM71.486 31.4234L67.846 47.7157H84.8957L85.7421 43.9275H73.6327L74.2294 41.256H85.8466L86.6778 37.5333H75.0607L75.5985 35.1241H87.4945L88.3211 31.4234H71.486Z"
                    fill="url(#paint6_linear_0_303)"
                />
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_0_303"
                    x1="-1.24776"
                    y1="8.73333"
                    x2="97.4602"
                    y2="8.73333"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#97272D"/>
                    <stop offset="1" stopColor="#ED1C24"/>
                </linearGradient>
                <linearGradient
                    id="paint1_linear_0_303"
                    x1="-1.24776"
                    y1="14.845"
                    x2="97.4601"
                    y2="14.845"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#97272D"/>
                    <stop offset="1" stopColor="#ED1C24"/>
                </linearGradient>
                <linearGradient
                    id="paint2_linear_0_303"
                    x1="100.114"
                    y1="14.845"
                    x2="1.40586"
                    y2="14.845"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#97272D"/>
                    <stop offset="1" stopColor="#ED1C24"/>
                </linearGradient>
                <linearGradient
                    id="paint3_linear_0_303"
                    x1="-1.24777"
                    y1="7.33472"
                    x2="97.4607"
                    y2="7.33472"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#97272D"/>
                    <stop offset="1" stopColor="#ED1C24"/>
                </linearGradient>
                <linearGradient
                    id="paint4_linear_0_303"
                    x1="51.5044"
                    y1="1.66201"
                    x2="51.5044"
                    y2="5.20088"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#959DAE"/>
                    <stop offset="0.17" stopColor="#959DAE" stopOpacity="0.86"/>
                    <stop offset="0.53" stopColor="#959DAE" stopOpacity="0.51"/>
                    <stop offset="1" stopColor="#959DAE" stopOpacity="0"/>
                </linearGradient>
                <linearGradient
                    id="paint5_linear_0_303"
                    x1="70.4482"
                    y1="3.57395"
                    x2="70.4482"
                    y2="5.88977"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#959DAE"/>
                    <stop offset="0.17" stopColor="#959DAE" stopOpacity="0.86"/>
                    <stop offset="0.53" stopColor="#959DAE" stopOpacity="0.51"/>
                    <stop offset="1" stopColor="#959DAE" stopOpacity="0"/>
                </linearGradient>
                <linearGradient
                    id="paint6_linear_0_303"
                    x1="61.1744"
                    y1="61.6832"
                    x2="35.6624"
                    y2="18.3519"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F2F2F2"/>
                    <stop offset="0.17" stopColor="#808080"/>
                    <stop offset="0.45" stopColor="white"/>
                    <stop offset="0.81" stopColor="#716E6F"/>
                    <stop offset="1" stopColor="#F2F2F2"/>
                </linearGradient>
                <clipPath id="clip0_0_303">
                    <rect width="100" height="48" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
}

export default CompanyLogoBlack;
